"use client";

import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import CustomSVG from "../_primitives/CustomSVG/CustomSVG.client";
import { ButtonTypes } from "./Button";
import { ComponentProps } from "react";

type ButtonProps = {
  btnClassName: string;
  isDownload: boolean;
  type: ButtonTypes;
  children: React.ReactNode;
  props: ComponentProps<"button">;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};
const ButtonClient = ({
  btnClassName,
  isDownload,
  type,
  children,
  props,
  onClick,
}: ButtonProps) => {
  const { getIcon } = useGlobalContext();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onClick?.(e);
  };
  return (
    <button
      onClick={handleClick}
      className={`${btnClassName} button-reset`}
      aria-label={props["aria-label"] ?? ""}
      {...(props as ComponentProps<"button">)}
    >
      {children}
      {type === "secondary" && (
        <CustomSVG
          src={getIcon("altArrowRight")}
          className="is-flex"
          wrapper={"span"}
          width={24}
          height={24}
          aria-hidden={true}
        />
      )}
      {type === "primary" && isDownload && (
        <CustomSVG
          src={getIcon("download")}
          className="is-flex"
          wrapper={"span"}
          width={16}
          height={16}
          aria-hidden={true}
        />
      )}
    </button>
  );
};

export default ButtonClient;
